<!--
 * @Descripttion: 基础弹窗模版
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 19:17:41
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-11-07 11:45:34
-->
<template>
	<div class="flex-row-align-center">
		<el-dialog
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:width="width"
			:before-close="handleClose"
			:show-close="showClose"
			:close-on-click-modal="closeOnClickModal"
		>
			<div class="p-4">
				<template v-if="!isShowInfo">
					<Empty size="120">
						<template #desc>
							<p class="font-h4-regular color-gy-9">认领后可查看联系方式</p>
							<p class="font-h6-regular color-gy-7">联系方式取自达人简介</p>
						</template>
					</Empty>
				</template>
				<template v-else>
					<div class="yx-border radius-8" v-for="(item, index) in content" :key="item.label" :class="{ 'mt-20': index > 0 }">
						<div class="flex-row-align-center myTalent-introductionDialog-titleBg flex-just-between">
							<div class="font-h6-medium flex-row-align-center color-gy-9">
								{{ item.label }}
								<Explain class="ml-4" :content="item.explain" placement="top"></Explain>
							</div>
							<div class="flex-row-align-center">
								<div v-if="item.updateTime" class="mr-8 color-gy-7 font-h6-regular">{{ item.updateTime }} 更新</div>
								<template v-if="item.showBtn2">
									<el-button v-if="item.key === 'partners'" :loading="loadingOpen" size="mini" @click="item.btn2Click">
										{{ loadingOpen ? '更新中' : '获取/更新' }}
									</el-button>
									<el-button v-else :loading="item.loadingBtn2" size="mini" @click="item.btn2Click">
										{{ item.labelBtn2 }}
									</el-button>
								</template>

								<el-tooltip v-if="item.showBtn1" :disabled="!item.disabledBtn1" effect="dark" content="已建联" placement="top">
									<el-button :disabled="item.disabledBtn1" @click="item.Btn1Click" size="mini" type="primary">
										{{ item.labelBtn1 }}
									</el-button>
								</el-tooltip>
							</div>
						</div>
						<div v-if="item.wechat || item.mobile || item.email" class="myTalent-introductionDialog-content flex-row-align-center color-gy-9">
							<div class="flex-1 pl-16 flex-row-align-center">
								<i class="i-talentCRM-myTalentDetail-weixin mr-8"></i>
								微信：{{ item.wechat || '-' }}
								<i class="ml-8 yx-color-text-secondary el-icon-copy-document cursor-pointer" @click="$copy(item.wechat)"></i>
								<rd-tag
									v-if="item.wechatState"
									class="ml-8"
									:value="is_add_wx === '1' ? '已加微信' : '未加微信'"
									tagType="success"
									:useByTable="false"
								></rd-tag>
							</div>
							<div class="flex-1 pl-16 flex-row-align-center">
								<i class="i-talentCRM-myTalentDetail-mobile mr-8"></i>
								手机：{{ item.mobile || '-' }}
							</div>
							<div class="flex-1 pl-16 flex-row-align-center" v-if="item.key === 'briefIntroduction'">
								<i class="i-talentCRM-myTalentDetail-email mr-8"></i>
								邮箱：{{ item.email || '-' }}
							</div>
						</div>
						<div v-else-if="!plugOk && item.key === 'partners'" class="myTalent-introductionDialog-content flex-row-align-center">
							<div class="pl-16 flex-row-align-center">
								<i class="el-icon-info yx-color-warning color-gy-9 pr-4"></i>
								<span class="fz-12">请前往【插件找达人】下载安装插件，即可自动获取并存储联系方式，</span>
								<span class="yx-color-warning fz-12 flex-row-align-center cursor-pointer" @click="goClueSeas">
									立即前往
									<i class="el-icon-arrow-right fz-14"></i>
								</span>
							</div>
						</div>
						<div v-else class="myTalent-introductionDialog-content flex-row-align-center">
							<div class="pl-16 flex-row-align-center">
								<i class="el-icon-info yx-color-warning color-gy-9 pr-4"></i>
								<span class="fz-12">{{ item.noContactPrompt }}</span>
							</div>
						</div>
					</div>
				</template>
			</div>
			<span slot="footer">
				<el-button type="primary" @click="confirm">知道了</el-button>
			</span>
		</el-dialog>
		<span @click.stop="show" slot="reference" class="cursor-pointe ml-4">
			<i class="i-introduction" style="width: 14px; display: inline-block"></i>
		</span>
		<!-----------   联系信息抽屉   ------------->
		<ContactInfoDrawer ref="contactInfoDrawer" :anchor_info="anchorInfo" @getList="getList"></ContactInfoDrawer>
		<!-- 建联 -->
		<AddContact ref="addContact" @getList="getList" :platformId="anchorInfo.platform_id" :anchorInfo="contactAnchorInfo"></AddContact>
	</div>
</template>
<script>
import {
	getAnchorDetail,
	descContact,
	getAnchorContactList,
	getMyTalentDetailCheckExist,
	syncAnchorBase,
	syncSphAnchorBase,
	loopSyncStatus,
	myTalentDetailSyncJxContact,
	myTalentDetailSyncKsContact,
	getJxContactInfo,
	getKsContactInfo,
} from '@/api/talentCRM';
import Explain from '@/components/common/explain';
import ContactInfoDrawer from '@/views/talentCRM/components/contactInfoDrawer/index.vue';
import { mapGetters } from 'vuex';
import debounce from 'lodash/throttle';
import AddContact from '@/views/common/dialog/addContact.vue';
import { callPlug } from '@/utils/bridge';
import dataMap from '../../../../utils/dataMap';
import { platformMixin } from '@rd/rd-ui';
export default {
	props: {
		anchor: {
			// 在详情页中 会有数据，列表也同样需要这个组件，列表中没有数据，需要自己拉取，并且也没有更新流程，这些都需要自己兼容，达人列表 团队公海 线索公海
			type: Object,
			default: null,
		},
		anchorId: {
			type: [String, Number],
		},
		isShowInfo: {
			type: [Boolean, Number],
			default: false,
		},
		anchorAsyncStatus: {
			type: [String, Number],
		},
		source: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			title: '查看联系方式', // 弹窗标题
			visible: false, // 弹窗显隐
			selfMobile: '', // 自建手机号
			selfWechat: '', // 自建微信号
			is_add_wx: '', // 是否已加微信
			mobile: '',
			wechat: '',
			email: '',
			loadingOpen: false,
			plugOk: false,
			canContact: {},
			anchorInfo: {
				partners: [],
			},
			syncLoading: false,
			addContactType: 'addContact',
			content: [],
		};
	},

	inject: {
		getAnchorDetail: {
			default: null,
		},
		getTalentManageTab: {
			default: () => false,
		},
		getTalentList: {
			default: () => false,
		},
		checkTalentCRMPermission: {
			default: () => {
				return {
					auth: false,
				};
			},
		},
	},
	components: {
		Explain,
		ContactInfoDrawer,
		AddContact,
	},
	mixins: [platformMixin],
	watch: {
		anchor: {
			handler: function (val, oldVal) {
				val &&
					((this.anchorInfo = {
						...val,
					}),
					this.setData());
			},
			immediate: true,
		},
	},

	computed: {
		...mapGetters(['isShopPartnerDataView', 'hasDrPartnerTag']),
		width() {
			return dataMap.DIALOG_SIZE_WIDTH[this.size];
		},
		contactAnchorInfo() {
			if (this.addContactType == 'addContact') {
				return { ...this.anchorInfo, mobile: this.mobile, wechat: this.wechat };
			} else {
				return {
					...this.anchorInfo,
					mobile: this.anchorInfo.jx_contact_mobile,
					wechat: this.anchorInfo.jx_contact_wechat,
				};
			}
		},
		updateTime() {
			if (this.anchorInfo.sync_base_real_time && this.anchorInfo.sync_base_real_time != '-') {
				return this.anchorInfo.sync_base_real_time.split(' ')[0];
			} else {
				return '';
			}
		},
		updateTimeOpen() {
			if (this.anchorInfo.jx_contact_time) {
				return this.anchorInfo.jx_contact_time.split(' ')[0];
			} else {
				return '';
			}
		},
		showContact() {
			return this.anchorInfo.partners.some(item => {
				const is = this.isSelf(item.user_id);
				return is;
			});
		},
		loadingUpdateStatus() {
			const {
				anchor,
				syncLoading,
				anchorInfo: { show_anchor_sync_status },
			} = this;
			return anchor ? this.anchorAsyncStatus : syncLoading ? 1 : show_anchor_sync_status;
		},

		contactInformationMap() {
			return new Map([
				[
					'establishingOneself',
					{
						key: 'establishingOneself',
						label: '自建联系方式',
						show:
							!this.isShopPartnerDataView && (this.source === 'emphasisTalent' || this.source === 'myTalent') && this.checkTalentCRMPermission.auth,
						explain: '在[我的达人/重点关注达人]模块手动录入的联系方式。',
						updateTime: '',
						showBtn2: true,
						loadingBtn2: false,
						labelBtn2: '查看更多',
						btn2Click: this.handleContactsDrawerShow,
						showBtn1: this.showContact && this.hasDrPartnerTag && this.$auth.hasPermi('system:talent:Construction'),
						labelBtn1: '新增',
						disabledBtn1: false,
						Btn1Click: this.handleLinkmanDialogShow,
						wechatState: true,
						wechat: this.selfWechat,
						mobile: this.selfMobile,
						noContactPrompt: '该达人无自建联系方式',
					},
				],
				[
					'briefIntroduction',
					{
						key: 'briefIntroduction',
						label: '达人简介联系方式',
						show: true,
						explain: '达人简介中所填联系方式',
						updateTime: this.updateTime,
						showBtn2: true,
						loadingBtn2: this.loadingUpdateStatus == 1,
						labelBtn2: this.loadingUpdateStatus == 1 ? '更新中' : '获取/更新',
						btn2Click: this.handleUpdate,
						showBtn1: this.showContact && this.$auth.hasPermi('system:talent:Construction'),
						labelBtn1: '建联',
						disabledBtn1: this.canContact[this.wechat || this.mobile],
						Btn1Click: this.handleAddContact,
						wechatState: false,
						wechat: this.wechat,
						mobile: this.mobile,
						email: this.email,
						noContactPrompt: '该达人无简介联系方式',
					},
				],
				[
					'partners',
					{
						key: 'partners',
						label: '达人广场公开联系方式',
						show: this.$auth.hasPermi('talentCRM:clueSeas:dyAlliance') && this.$isPlatOr(this.anchorInfo.platform_id, ['Dy', 'Ks']),
						explain: '官方达人广场达人详情所公开联系方式，查看联系方式需消耗每日可查看次数',
						updateTime: this.updateTimeOpen,
						showBtn2: this.$auth.hasPermi('talentCRM:clueSeas:dyAlliance:contact'),
						loadingBtn2: this.loadingOpen,
						labelBtn2: this.loadingOpen ? '更新中' : '获取/更新',
						btn2Click: this.judgeUpdate,
						showBtn1: this.showContact && this.$auth.hasPermi('system:talent:Construction'),
						labelBtn1: '建联',
						disabledBtn1: this.canContact[this.anchorInfo.jx_contact_wechat || this.jx_contact_mobile],
						Btn1Click: this.handleAddContactOpen,
						wechatState: false,
						wechat: this.anchorInfo.jx_contact_wechat,
						mobile: this.anchorInfo.jx_contact_mobile,
						noContactPrompt: '该达人无公开联系方式',
					},
				],
			]);
		},
	},
	created() {
		this.initData();
	},
	methods: {
		// 前往下载插件的页面
		goClueSeas() {
			const { href } = this.$router.resolve({ path: '/talentCRM/clueSeas?tab=dyAlliance&platform_id=' + this.anchorInfo.platform_id });
			window.open(href, '_blank');
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 弹窗尺寸，small:400px，normal:600px，large:800px
			this.size = 'large';
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},

		async getList() {
			await this.getInfo();
			await this.getCanContact();
			this.setData();
			this.getTalentManageTab();
			this.getTalentList();
		},

		// 判断更新还是获取
		async judgeUpdate() {
			const { jx_contact_wechat, jx_contact_mobile } = this.anchorInfo;
			// 更新逻辑
			if (jx_contact_wechat || jx_contact_mobile) {
				this.handleUpdateOpen();
			} else {
				if (this.$isPlatOr(this.anchorInfo.platform_id, ['Dy', 'Ks']) && !this.anchorInfo.anchor_uid) {
					return this.$message.warning('暂未获取达人信息，请先前往达人详情刷新获取达人信息');
				}

				// 获取逻辑
				let api = {
					[dataMap.PLATFORM_DY.value]: getJxContactInfo,
					[dataMap.PLATFORM_KS.value]: getKsContactInfo,
				};
				let anchorUidParams = {
					[dataMap.PLATFORM_DY.value]: this.anchorInfo.anchor_uid,
					[dataMap.PLATFORM_KS.value]: this.anchorInfo.anchor_uid,
				};
				const { status } = await api[this.anchorInfo.platform_id]({
					anchorUid: anchorUidParams[this.anchorInfo.platform_id],
				});
				// 存在本地达人库 ？存在则直接调用列表接口，不存在沿用老逻辑插件获取
				status == 1 ? this.refreshAnchorDetail() : this.handleUpdateOpen();
			}
		},

		async handleUpdate() {
			this.anchor ? this.$emit('syncAnchorBase') : this.syncAnchorBase();
		},
		syncAnchorBase: debounce(async function () {
			if (this.anchorInfo.is_effective == 1) {
				return;
			}
			const { anchor_id } = this.anchorInfo;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: syncAnchorBase,
				[dataMap.PLATFORM_KS.value]: syncAnchorBase,
				[dataMap.PLATFORM_SP.value]: syncSphAnchorBase,
			};
			const parmas = {
				[dataMap.PLATFORM_DY.value]: { anchor_id },
				[dataMap.PLATFORM_KS.value]: { anchor_id },
				[dataMap.PLATFORM_SP.value]: { anchorId: anchor_id },
			};
			const { code } = await temPF[this.anchorInfo.platform_id](parmas[this.anchorInfo.platform_id]);
			if (code !== 0) return;
			this.$message.success('数据更新中...');
			this.loopFetch();
			this.syncLoading = true;
		}, 300),

		async loopFetch() {
			const res = await loopSyncStatus({ anchor_id: this.anchorInfo.anchor_id });
			if (res.code !== 0) return;
			if (res.data.show_anchor_sync_status == 1) {
				this.loopTask = setTimeout(() => {
					this.loopFetch();
				}, 3000);
			} else {
				this.syncLoading = false;
				this.$emit('anchorRefresh');
			}
		},
		async handleUpdateOpen() {
			this.loadingOpen = true;
			const temPFParams = {
				[dataMap.PLATFORM_DY.value]: 'plugMyTalentUpdateAnchorInfo',
				[dataMap.PLATFORM_KS.value]: 'plugMyTalentUpdateAnchorInfo_ks',
			};
			const temPFUnId = {
				[dataMap.PLATFORM_DY.value]: this.anchorInfo.union_id,
				[dataMap.PLATFORM_KS.value]: this.anchorInfo.anchor_uid,
			};
			const account = {
				[dataMap.PLATFORM_DY.value]: this.anchorInfo.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.anchorInfo.anchor_uid,
			};
			try {
				const res = await callPlug(temPFParams[this.anchorInfo.platform_id], {
					anchorAccount: account[this.anchorInfo.platform_id],
					anchorName: this.anchorInfo.anchor_name,
					union_id: temPFUnId[this.anchorInfo.platform_id],
				});
				let api = {
					[dataMap.PLATFORM_DY.value]: myTalentDetailSyncJxContact,
					[dataMap.PLATFORM_KS.value]: myTalentDetailSyncKsContact,
				};
				let anchorUidParams = {
					[dataMap.PLATFORM_DY.value]: this.anchorInfo.anchor_uid,
					// [dataMap.PLATFORM_XHS.value]: this.anchorInfo.anchor_uid,
					// [dataMap.PLATFORM_SP.value]: this.anchorInfo.third_anchor_uid,
					[dataMap.PLATFORM_KS.value]: this.anchorInfo.anchor_uid,
				};
				await api[this.anchorInfo.platform_id]({
					jxContactWechat: res.jxContactWechat,
					jxContactMobile: res.jxContactMobile,
					anchorAccount: account[this.anchorInfo.platform_id],
					anchorUid: anchorUidParams[this.anchorInfo.platform_id],
				});

				this.$message({
					message: '更新成功',
					type: 'success',
				});
				this.refreshAnchorDetail();
			} finally {
				this.loadingOpen = false;
			}
		},
		refreshAnchorDetail() {
			this.anchor ? this.getAnchorDetail() : this.getAnchorDetailDefault();
		},

		// 获取自建联系人列表，取第一条
		async getInfo() {
			try {
				const { code, data: { list = [] } = {} } = await getAnchorContactList({ anchor_id: this.anchorInfo.anchor_id });
				if (code === 0) {
					const { mobile, wechat_account, is_add_wx } = list[0] || {};
					this.selfMobile = mobile;
					this.selfWechat = wechat_account;
					this.is_add_wx = is_add_wx;
				}
			} catch (error) {
				console.error('Error in getInfo:', error);
			}
		},
		// 获取简介联系方式
		async getDescContact() {
			const { anchorInfo } = this;
			const { mobile = '', wechat = '', email = '' } = await descContact({ anchorId: anchorInfo.anchor_id });
			this.mobile = mobile;
			this.wechat = wechat;
			this.email = email;
		},

		async getCanContact() {
			const wechatAccounts = [];
			const selfWechat = this.selfWechat || this.selfMobile || '';
			const wechat = this.wechat || this.mobile || '';
			const openWechat = this.anchorInfo.jx_contact_wechat || this.anchorInfo.jx_contact_mobile || '';
			selfWechat && wechatAccounts.push(selfWechat);
			wechat && wechatAccounts.push(wechat);
			openWechat && wechatAccounts.push(openWechat);
			if (wechatAccounts.length) {
				const data = await getMyTalentDetailCheckExist({
					anchorId: this.anchorInfo.anchor_id,
					wechatAccounts,
				});
				this.canContact = data;
			}
		},
		// 获取达人详情
		async getAnchorDetailDefault() {
			const { code, data: { anchor_info } = {} } = await getAnchorDetail({ anchor_id: this.anchorId });
			if (code == 0) {
				this.loading = false;
				this.anchorInfo = anchor_info;
				this.setData();
			}
		},
		handleAddContact() {
			this.addContactType = 'addContact';
			this.$nextTick(this.$refs['addContact'].show);
		},
		handleAddContactOpen() {
			this.addContactType = 'addContactOpen';
			this.$nextTick(this.$refs['addContact'].show);
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
			this.loopTask && clearTimeout(this.loopTask);
			this.loopTask = null;
		},
		handleLinkmanDialogShow() {
			this.$refs.contactInfoDrawer.showLinkmanDialog();
		},
		// 主动显示弹窗
		async show() {
			if (!this.anchor) {
				await this.getAnchorDetailDefault();
			}
			this.plugOk = window.cytPlugOk;
			await Promise.all([this.getDescContact(), this.getInfo(), this.getCanContact()]);
			this.setData();
			this.visible = true;
		},
		// 确认按钮点击事件
		confirm() {
			this.handleClose();
		},
		// 修改弹窗内的数据
		setData() {
			this.content = Array.from(this.contactInformationMap.values()).filter(item => item.show);
		},
		handleContactsDrawerShow() {
			this.$refs.contactInfoDrawer.show();
			this.handleClose();
		},
	},
};
</script>

<style lang="less">
.myTalent-introductionDialog-titleBg {
	background: #f9f8fd;
	height: 56px;
	padding: 0 16px;
}

.myTalent-introductionDialog-content {
	height: 56px;
}
</style>
